"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.clearfix = void 0;

var _styledComponents = require("styled-components");
/**
 * Module dependencies.
 */

/**
 * Export `clearfix`.
 */


var clearfix = (0, _styledComponents.css)(["&::after,&::before{box-sizing:border-box;content:' ';display:table;}&::after{clear:both;}"]);
exports.clearfix = clearfix;